import type { Messages } from "@prop/i18n";
import type en from "../en/multiaccount";

export default {
  signal: {
    same_person: "misma persona",
    same_document: "mismo documento KYC",
    same_device: "mismo dispositivo",
    same_fingerprint: "misma huella del navegador",
    same_wallet: "misma billetera de payouts",
    same_email: "mismo buzón (alias de correo)",
    shared_ip: "misma red",
  },
  trader: {
    refused: "Payout rechazado: este perfil está vinculado a otro perfil con un challenge o una cuenta funded (una persona — un perfil). La solicitud está en revisión por nuestro equipo; las compras, el trading y los reinicios siguen funcionando.",
    historyReason: "multicuentas",
  },
  queue: {
    refused: "Rechazado — multicuentas",
    live: "Vinculado a {n} perfil(es) con cuentas de programa",
    overridden: "Multicuentas anulado: {reason}",
    upheld: "Rechazo confirmado: {reason}",
    reviewTitle: "Revisar el rechazo",
    reasonLabel: "Motivo por escrito (obligatorio)",
    reasonHint: "Al menos 10 caracteres — por ejemplo, una familia que comparte una computadora.",
    override: "Anular y devolver a la cola",
    uphold: "Confirmar rechazo",
    cancel: "Cancelar",
    review: "Revisar",
  },
  view: {
    tab: "Multicuentas",
    title: "Perfiles vinculados",
    lead: "Perfiles que comparten un dispositivo, un documento KYC, una billetera de payouts o un buzón — o una huella del navegador junto con una red. El payout de un perfil vinculado a otro con un challenge o una cuenta funded se rechaza automáticamente; el equipo lo revisa en Payouts.",
    hints: "Mostrar también vínculos débiles (solo red o solo huella)",
    empty: "No hay perfiles vinculados.",
    members: "Perfiles",
    pairs: "Vínculos",
    blocking: "bloquea payouts",
    hint: "solo indicio",
    accounts: "Cuentas",
    noAccounts: "sin cuentas de programa",
    refused: "{n} payout(s) rechazado(s) en espera",
    paid: "{n} pagado(s)",
    since: "desde {at}",
  },
} satisfies Messages<typeof en>;
